module.exports = __webpack_public_path__ + "img/mb_3.c18ae782.jpg";